export default __webpack_public_path__ + "e1820977fff67278848bbebba6fb5e5a.svg";